
import state from './moduleKanbanState.js'
import mutations from './moduleKanbanMutations.js'
import actions from './moduleKanbanActions.js'
import getters from './moduleKanbanGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}